/* eslint-disable max-len */
import {decryptData} from '@/utils/encryptionUtils';
import {checkAccessRoles} from '@/utils/constants';

function getRolesPantalla(_tipoPermiso) {
  const encryptedData = localStorage.getItem('_config');
  const decryptedData = decryptData(encryptedData);
  if (decryptedData) {
    const rolesPorPantalla = JSON.parse(decryptedData).rolesPantalla;
    if (rolesPorPantalla && Object.keys(rolesPorPantalla).length !== 0) {
      return rolesPorPantalla[_tipoPermiso] || [999];
    } else {
      return [999];
    }
  }
}

/* Funcion para añadir items al desplegable del menu de las tablas
  - items: Variables donde se añadira el item
  - store: Variable store de vuex
  - roles: Array de roles para filtrar ejemplo: ['SuperAdministrador', 'Administrador']
  - label: Texto que identifica al item
  - icon: icono que se mostrara, usado los icons de PrimeIcons
  - action: acción a realizar cuando se hace click
*/
function addItem(items, store, roles, label, icon, action, excepcion = true, codeIcon = '') {
  if (excepcion) {
    if (checkAccessRoles(store, roles)) {
      items.push({
        label: label,
        icon: icon,
        codeIcon: codeIcon,
        command: action,
      });
    }
  }
}

/* Funcion para añadir items al desplegable del menu de las tablas
  - items: Variables donde se añadira el item
  - store: Variable store de vuex
  - roles: Array de roles para filtrar ejemplo: ['SuperAdministrador', 'Administrador']
  - label: Texto que identifica al item
  - icon: icono que se mostrara, usado los icons de PrimeIcons
  - children: Array de hijos que se añadirean ejemplo:
    [
      {
        roles: ['SuperAdministrador', 'Administrador', 'RegistrarAsif'],
        label: 'Registro ASIF',
        icon: 'pi pi-clone',
        function: () => emitirNotificacionASIF(),
      },
    ]
*/
function addItemChildren(
  items,
  store,
  roles,
  label,
  icon,
  children,
  excepcion = true,
) {
  if (excepcion) {
    if (checkAccessRoles(store, roles)) {
      items.push({
        label: label,
        icon: icon,
        items: children.map((element) => {
          if (checkAccessRoles(store, element.roles)) {
            return {
              label: element.label,
              icon: element.icon,
              command: element.function,
            };
          }
        }),
      });
    }
  }
}

/* Funcion que sirve para cambiar la miga de pan cuando es un expediente trasladado
  - itemExtra: Es un objeto que se le pasara cuando se quiera cambiar mas partes de la miga de pan
    ejemplo:
    {
      name: 'SeguimientoDetalleView',
      newData: {
        label: `Registro Expediente (${route.params.registroExpedienteId})`,
      },
    },
*/
async function changeBreadExpediente(store, route, itemExtra) {
  const expediente = store.getters['expediente/getExpediente'];
  const editarTrasladado = store.getters['expediente/getEditarTrasladado'];
  const trasladado = editarTrasladado ?
    '' :
    `- TRASLADADO (${expediente.unidadNombreCorto})`;

  const arrayBreadCrumbs = [
    {
      name: 'ExpedienteDetalleView',
      newData: {
        label: `${expediente?.codigoExpediente} (${route.params.id}) ${trasladado}`,
      },
    },
  ];
  if (itemExtra) {
    arrayBreadCrumbs.push(itemExtra);
  }
  await store.commit('breadcrumbs/changeBreads', arrayBreadCrumbs);

  /* Seleccionamos el link de la miga de pan para ponerlo en rojo para traslado */
  const arrayEnlace = document.querySelectorAll('.bread__link');

  if (arrayEnlace) {
    if (!editarTrasladado) {
      arrayEnlace[1].innerHTML = `<span class="text-red-500">
      ${expediente?.codigoExpediente} (${route.params.id}) 
      - TRASLADADO (${expediente.unidadNombreCorto})</span>`;
    } else {
      arrayEnlace[1].innerHTML = `${expediente?.codigoExpediente} 
        (${route.params.id})`;
    }
  }
}

/* Funcion para validar el NIF NIE CIF */
function validDNI(value) {
  const validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
  const nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]$/i;
  const nieRexp = /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]$/i;
  const cifRexp = /^[ABCDEFGHJKLMNPQRSUVW][0-9]{7}[0-9A-J]$/i;

  const str = value?.toString().toUpperCase();

  if (nifRexp.test(str) || nieRexp.test(str)) {
    const nie = str
      .replace(/^[X]/, '0')
      .replace(/^[Y]/, '1')
      .replace(/^[Z]/, '2');
    const letter = str.substr(-1);
    const charIndex = parseInt(nie.substr(0, 8)) % 23;

    const dniNie = validChars.charAt(charIndex) === letter;
    return dniNie ? 'dni' : false;
  }

  if (cifRexp.test(str)) {
    const num = str.substr(1, 7);
    const controlChar = str.substr(-1);
    const sumPares = parseInt(num[1]) + parseInt(num[3]) + parseInt(num[5]);
    const sumImpares = [...num[0], num[2], num[4], num[6]].reduce(
      (acc, digit) => {
        const dbl = (parseInt(digit) * 2).toString();
        return acc + parseInt(dbl[0]) + (dbl[1] ? parseInt(dbl[1]) : 0);
      },
      0,
    );

    const total = sumPares + sumImpares;
    const controlDigit = (10 - (total % 10)) % 10;
    const validLetters = 'JABCDEFGHI';

    const aux = /[0-9]/.test(controlChar) ?
      controlDigit === parseInt(controlChar) :
      validLetters.charAt(controlDigit) === controlChar;
    return aux ? 'cif' : false;
  }
  return false;
}

const openJustificante = (_justificante) => {
  const nuevaVentana = window.open('', '_blank');
  nuevaVentana.document.write(`
    <html>
    <head>
        <title>XML en Nueva Ventana</title>
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.9.0/styles/github.min.css">
        <script src="https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.9.0/highlight.min.js"></script>
        <style>
          pre code {
            font-size: 16px;
            font-family: "Fira Code", monospace;
          }
          .hljs-tag {
            font-weight: bold;
            color: #E91E63;
          }
          .hljs-name {
            color:#00c608;
          }
          .hljs-attr {
            color: #03A9F4;
          }
          .hljs-string {
            color:#FF9800;
          }
        </style>
    </head>
    <body>
        <pre><code class="language-html">${_justificante.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</code></pre>
        <script>
            document.addEventListener("DOMContentLoaded", () => {
                document.querySelectorAll("pre code").forEach(el => {
                    hljs.highlightElement(el);
                });
            });
        </script>
    </body>
    </html>
`);
  nuevaVentana.document.close();
};

const abrirJsonEnPestana = (jsonData) => {
  const nuevaVentana = window.open('', '_blank');

  nuevaVentana.document.write(`
    <html>
    <head>
        <meta charset="UTF-8">
        <title>JSON Viewer</title>
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/codemirror/5.65.14/codemirror.min.css">
        <script src="https://cdnjs.cloudflare.com/ajax/libs/codemirror/5.65.14/codemirror.min.js"></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/codemirror/5.65.14/mode/javascript/javascript.min.js"></script>
        <style>
          html, body {
              margin: 0;
              padding: 0;
              height: 100%;
              width: 100%;
              overflow: hidden;
          }
          #jsonDisplay {
              width: 100%;
              height: 100vh;
          }
          .CodeMirror {
              height: 100vh !important;
              width: 100vw !important;
          }
        </style>
    </head>
    <body>
        <textarea id="jsonDisplay"></textarea>
        <script>
            document.addEventListener("DOMContentLoaded", () => {
                const editor = CodeMirror.fromTextArea(document.getElementById("jsonDisplay"), {
                    mode: "application/json",
                    lineNumbers: true,
                    theme: "default",
                    readOnly: true
                });

                // Formatear el JSON correctamente con 4 espacios de indentación
                editor.setValue(JSON.stringify(${jsonData}, null, 4));
            });
        </script>
    </body>
    </html>
  `);

  nuevaVentana.document.close();
};


export {
  getRolesPantalla,
  addItem,
  addItemChildren,
  changeBreadExpediente,
  validDNI,
  openJustificante,
  abrirJsonEnPestana,
};
